var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "Exit Forms",
        backLink: "/dashboard/reports",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.retryLoading, "z-index": "999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "soli-subtitle" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `${_vm.globalMomentMonthFull(
                                        _vm.rangeStart
                                      )} ${_vm.globalMomentYear(
                                        _vm.rangeStart
                                      )}`
                                    ) + "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                { staticStyle: { "white-space": "normal" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.allLocations
                                        ? "Exit Forms By Location"
                                        : _vm.selectedLocation.name
                                    ) + "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "font-bold py-1",
                                  staticStyle: { "white-space": "normal" },
                                },
                                [
                                  _vm.can("View admin reports")
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "soli-round soli-blue-text",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.range(
                                                0,
                                                !_vm.allLocations
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.allLocations
                                                ? `View ${_vm.selectedLocation.name}`
                                                : `View All Locations`
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.allLocations
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "soli-round soli-blue-text",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.expanded.length
                                                ? (_vm.expanded = [])
                                                : (_vm.expanded = _vm.exits)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.expanded
                                                ? "Detail View"
                                                : "List View"
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        left: "",
                                        "offset-y": "",
                                        "max-width": "250",
                                        "close-on-content-click": false,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "elevation-3 mr-4",
                                                      attrs: {
                                                        small:
                                                          _vm.$vuetify
                                                            .breakpoint.xs,
                                                        icon: "",
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-badge",
                                                    {
                                                      attrs: {
                                                        color: "accent",
                                                        overlap: "",
                                                        bordered: "",
                                                        dot: "",
                                                        value: _vm.search,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "soli-blue-text text-shadow-blue",
                                                        },
                                                        [_vm._v("tune")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        [
                                          _c(
                                            "v-list-item",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Filter",
                                                  "single-line": "",
                                                  outlined: "",
                                                  dense: "",
                                                  clearable: "",
                                                  "append-icon": _vm.search
                                                    ? null
                                                    : "tune",
                                                  "hide-details": "",
                                                },
                                                model: {
                                                  value: _vm.search,
                                                  callback: function ($$v) {
                                                    _vm.search = $$v
                                                  },
                                                  expression: "search",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.allLocations
                                            ? _c(
                                                "v-list-item",
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      label: "Group By",
                                                      dense: "",
                                                      outlined: "",
                                                      "item-text": "display",
                                                      "item-value": "value",
                                                      items: [
                                                        {
                                                          display:
                                                            "Total Exits",
                                                          value: null,
                                                        },
                                                        {
                                                          display: "Location",
                                                          value: "location",
                                                        },
                                                        {
                                                          display: "Date",
                                                          value: "date",
                                                        },
                                                      ],
                                                      "return-object": "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.setGroupBy(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.groupBy,
                                                      callback: function ($$v) {
                                                        _vm.groupBy = $$v
                                                      },
                                                      expression: "groupBy",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elevation-3",
                                      attrs: {
                                        small: _vm.$vuetify.breakpoint.xs,
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.range(-1, _vm.allLocations)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "dark" } },
                                        [_vm._v("chevron_left")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elevation-3 ml-1",
                                      attrs: {
                                        small: _vm.$vuetify.breakpoint.xs,
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.range(1, _vm.allLocations)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "dark" } },
                                        [_vm._v("chevron_right")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  false
                                    ? _c("v-text-field", {
                                        staticClass: "pl-6",
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          "append-icon": "filter_list",
                                          label: "Filter",
                                          "single-line": "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function ($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.allLocations && !_vm.byLocation
                    ? _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.exits,
                          "hide-default-footer": "",
                          "disable-pagination": "",
                          "mobile-breakpoint": "0",
                          search: _vm.search,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `location`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center py-2" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.location) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: `total`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center py-2" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.total) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.allLocations || _vm.byLocation
                    ? _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.exits,
                          "hide-default-footer": "",
                          "disable-pagination": "",
                          "mobile-breakpoint": "0",
                          search: _vm.search,
                          "group-by": _vm.groupBy.value,
                          "show-expand": "",
                          expanded: _vm.expanded,
                        },
                        on: {
                          "update:expanded": function ($event) {
                            _vm.expanded = $event
                          },
                          "click:row": function ($event) {
                            null /*showExitForm = $event*/
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `item.info`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center py-2" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          item.info.user_id
                                            ? _c(
                                                "Link",
                                                {
                                                  attrs: {
                                                    href: `/profile/${item.info.user_id}/account`,
                                                  },
                                                },
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(item.info.name) +
                                                        "\n                                    "
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(item.info.name) +
                                                    "\n                                "
                                                ),
                                              ]),
                                          _vm._v(" "),
                                          _c("v-list-item-subtitle", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.info.email) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.student`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center py-2" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.student.name) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.status`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "white--text font-bold",
                                      attrs: {
                                        small: "",
                                        color:
                                          item.status == "Pending"
                                            ? "soli-status-red"
                                            : item.status == "Processed"
                                            ? "soli-status-green"
                                            : "soli-status-blue",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.status) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.date`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center py-2" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.globalMomentDate(
                                                    new Date(item.date)
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "expanded-item",
                              fn: function ({ headers, item }) {
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "ma-3",
                                      attrs: { colspan: headers.length },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "ma-3" },
                                        [
                                          _c("v-simple-table", [
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Final lesson\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Why exit?\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Other")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Perfect match?\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Why?")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Confidential?\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.form.recommend
                                                  ? _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                Recommend us?\n                                            "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("NPS")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                NPS reason?\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Re-enroll?\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("When?")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Do better?\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.globalMomentDate(
                                                          new Date(
                                                            item.form.final_lesson_date
                                                          )
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex-col" },
                                                    _vm._l(
                                                      item.form.why_exit,
                                                      function (reason) {
                                                        return _c(
                                                          "div",
                                                          { key: reason },
                                                          [
                                                            _c("small", [
                                                              _vm._v(
                                                                "\n                                                            · " +
                                                                  _vm._s(
                                                                    reason
                                                                  ) +
                                                                  "\n                                                        "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form
                                                          .why_exit_reason
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form.perfect_match
                                                          ? "Yes"
                                                          : "No"
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form
                                                          .perfect_match_reason
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form.confidential
                                                          ? "Yes"
                                                          : "No"
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                item.form.recommend
                                                  ? _c("td", [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.form.recommend
                                                              ? "Yes"
                                                              : "No"
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form.nps_value
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form.nps_reason
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form.will_return
                                                          ? "Yes"
                                                          : "No"
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form.return_date
                                                          ? _vm.globalMomentDate(
                                                              new Date(
                                                                item.form.return_date
                                                              )
                                                            )
                                                          : null
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        item.form.do_better
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                              ]),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }